export const USERNAME = "username";
export const PASSWORD = "password";
export const SENT = "sent";

// Valori iniettati a build-time da webpack (DefinePlugin) a partire dal .env.
// Sono obbligatori: il build fallisce se non definiti (vedi webpack.config.js).
export const LOGIN_URL = process.env.CRM_LOGIN_URL;
export const ADD_EMAIL_URL = process.env.CRM_ADD_EMAIL_URL;
